<template>
  <div class="x-tablelist-view" data-automation="manageProduct">
    <div class="search-warp">
      <add-imei-input v-model="filter.deviceImeis" :showAdd="false"></add-imei-input>

      <ux-select v-model="filter.mcType" clearable :options="allMctype" :props="{ label: 'name', value: 'name' }"
        :placeholder="$t('HT.upgrade.mctype')"></ux-select>

      <ux-select v-model="filter.source" clearable :options="platform" :props="{ label: 'name', value: 'name' }"
        :placeholder="$t('HT.advancedService.sourcePlatform')"></ux-select>
      <ux-select v-model="filter.strategyStatus" clearable :options="$opt.serviceStatus"
        :placeholder="$t('HT.advancedService.serviceStatus')"></ux-select>

      <el-button type="primary" @click="seach" size="small">{{
        $t('HT.search')
      }}</el-button>
      <el-button plain @click="reset" size="small">{{
        $t('HT.reset')
      }}</el-button>
    </div>


    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table ref="table" :showPage="showPage" maxHeight="100%" :hide-on-single-page="true" :data="tableData.list"
        :columns="columns" :total="tableData.totalSize" :size.sync="filter.size" :page.sync="filter.page"
        @changePage="changePage" @changeSize="changeSize" :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"></ux-table>
    </div>
  </div>
</template>

<script lang="jsx">
import AddImeiInput from '@/components/AddImeiInput/index.vue';
import { strategyStatusFilter } from '@/filters';
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    AddImeiInput
  },
  data() {
    return {
      productList: [],
      serviceTypeList: [],
      userData: {}, // 登录者信息
      showPage: true,
      columns: [
        // 表头数据
        {
          label: this.$t('HT.label.imei'),
          tooltip: true,
          align: 'left',
          prop: 'deviceImei',
        },
        {
          label: this.$t('HT.advancedService.positionType.mctype'),
          prop: 'mcType',
          align: 'left',
          tooltip: true,
        },
        {
          label: this.$t('HT.advancedService.current.serviceName'),
          prop: 'serviceName',
          align: 'left',
          tooltip: true,
        },
        {
          label: this.$t('HT.advancedService.serviceStatus'),
          prop: 'strategyStatus',
          align: 'left',
          tooltip: true,
          render:(h,data)=><span class="form-val" style={{color:['', '#3DC456', '#E6A23C','#F45C5C'][data.strategyStatus]}}>{ this.$opt.switchStr(data.strategyStatus, this.$opt.serviceStatus) }</span>
        },
        {
          label: this.$t('HT.label.todayCall'),
          prop: 'todayCallCount',
          align: 'left',
          tooltip: true,
          width: 190,
        },

        {
          label: this.$t('HT.label.totalCall'),
          prop: 'totalCallCount',
          align: 'left',
          tooltip: true,
          width: 200,
        },

        {
          label: this.$t('HT.addLicense.expireDate'),
          prop: 'first_call_time',
          align: 'left',
          tooltip: true,
          width: 200,
          render: (h, data) => <div>
            <p>{this.$t('HT.advancedService.effective')}：{data.orderStartTime}</p>
            <p>{this.$t('HT.advancedService.expired')}：{data.orderEndTime}</p>
          </div>
        },


        {
          label: this.$t('HT.advancedService.sourcePlatform'),
          prop: 'source',
          align: 'left',
          tooltip: true,
        },

        {
          label: this.$t('HT.advancedService.userAccount'),
          prop: 'userAccount',
          align: 'left',
          tooltip: true,
        },

        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(92),
          align: 'left',
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [
                  this.$t('HT.common.detail'),
                ],
                className: [
                  '',
                  this.userData.supervisor && params.published != 2 ? '' : 'no-click',
                  params.published == 0 ? 'no-click' : '',
                  ''
                ],
                event: ['goToDetail']
              },
              on: {
                // 管理
                goToDetail: () => {
                  this.goToDetail(params);
                },

              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        serviceType: 'LBS',
        deviceImeis: '',
        mcType: '',
        source: '',
        strategyStatus: '',
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.filter.mcType = this.$route.query.mcType || '';
    this.getAllServiceType();
    this.getPlatform();
    this.getAllList();
    this.getAllMctype()
    this.userData = this.$store.state.login.userData;
  },
  computed: {
    ...mapState('advancedService', ['platform','allMctype'])
  },
  methods: {
    ...mapActions('advancedService', ['getPlatform','getAllMctype']),
    async getAllServiceType() {
      let { code, data } = await this.$api.advancedService.getAllServiceType();
      code === 10000 && (this.serviceTypeList = data);
    },
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getAllList() {
      const [startTime, endTime] = this.filter.date || [];
      const params = Object.assign({}, this.filter, { startTime, endTime });
      this.$uxLoading.show();
      this.$api.advancedService.getDeviceList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },


    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getAllList();
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getAllList();
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getAllList();
    },
    reset() {
      this.filter.serviceType = 'LBS';
      this.filter.deviceImeis = '';
      this.filter.mcType = '';
      this.filter.source = '';
      this.filter.strategyStatus = '';
      this.filter.page = 1;
      this.filter.size = 10;
      this.getAllList();
    },
    goToDetail(params) {
      this.$router.push({ path: '/advancedService/device/detail', query: { deviceImei: params.deviceImei, serviceType: this.filter.serviceType } });
    },

  }
};
</script>
<style lang="scss" scoped>
.search-warp {
  display: flex;

  >div {
    width: auto !important;
    margin-right: 10px;
    display: inline-block;
  }
}

.ux-search-option {
  z-index: 10;
}
</style>